import React from "react";
import { Modal, Button } from "../../../../../components";
import FormFieldSet from "../../../../../components/FormFields/FormFieldSet";

const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, part) => acc?.[part], obj);

const toPickerDate = (val) => {
  if (!val || val === "-") return "";
  if (typeof val === "string") {
    if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
      // DD-MM-YYYY -> MM-DD-YYYY
      const [dd, mm, yyyy] = val.split("-");
      return `${mm}-${dd}-${yyyy}`;
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      // YYYY-MM-DD -> MM-DD-YYYY
      const [yyyy, mm, dd] = val.split("-");
      return `${mm}-${dd}-${yyyy}`;
    }
  }
  return val;
};

/* ─── Edit Modal (supports text, datepicker, select, number) ─── */
const EditSectionModal = ({ isOpen, onClose, title, fields, data, onSave, saveLabel, onChange, children }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    titleColor="primary"
    width="max-w-4xl"
    showCloseButton
  >
    <div className="grid grid-cols-3 gap-4 py-2">
      {fields.map(({ label, key, type = "text", options, searchOptions, onSearch, loading, disabled }) => {
        const value = getNestedValue(data, key);

        if (type === "select") {
          return (
            <FormFieldSet
              key={key}
              type="select"
              title={label}
              value={value}
              options={options || []}
              onChange={(val) => onChange(key, val)}
              size="sm"
              placeholder={label}
              showSearch
              disabled={disabled}
            />
          );
        }

        if (type === "custom-search-select") {
          return (
            <FormFieldSet
              key={key}
              type="select"
              title={label}
              value={value}
              options={searchOptions || []}
              onChange={(val) => onChange(key, val)}
              size="sm"
              placeholder={label}
              showSearch
              loading={loading}
              onSearch={onSearch}
              disabled={disabled}
            />
          );
        }

        if (type === "datepicker") {
          return (
            <FormFieldSet
              key={key}
              type="datepicker"
              title={label}
              value={toPickerDate(value) || ""}
              onChange={(val) => onChange(key, val)}
              size="sm"
              placeholder={label}
              showDropdown={false}
              disabled={disabled}
            />
          );
        }

        if (type === "phone") {
          return (
            <FormFieldSet
              key={key}
              type="phone"
              title={label}
              code={typeof value === "object" ? (value.countryCode || value.code || "") : ""}
              value={typeof value === "object" ? value.number : value || ""}
              onChange={(full, details) => onChange(key, details)}
              size="sm"
              placeholder={label}
              disabled={disabled}
            />
          );
        }

        if (type === "number") {
          return (
            <FormFieldSet
              key={key}
              type="text"
              title={label}
              value={value || ""}
              onChange={(e) => onChange(key, e?.target?.value ?? e)}
              size="sm"
              placeholder={label}
              inputType="number"
              disabled={disabled}
            />
          );
        }

        // Default: text
        return (
          <FormFieldSet
            key={key}
            type="text"
            title={label}
            value={value || ""}
            onChange={(e) => onChange(key, e?.target?.value ?? e)}
            size="sm"
            placeholder={label}
            disabled={disabled}
          />
        );
      })}
    </div>
    {children}
    <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 mt-4">
      <Button type="button" title="Cancel" variant="outlined" color="black" size="sm" onClick={onClose} />
      <Button type="button" title={saveLabel} variant="contained" color="primary" size="sm" onClick={onSave} />
    </div>
  </Modal>
);

export default EditSectionModal;
